import React, { useEffect, useRef } from "react";

export default function SelectableTable(props) {
    const checkRef = useRef();

    const { total, selected } = props;

    useEffect(() => {
        if (selected && selected !== total) {
            checkRef.current.indeterminate = true;
            checkRef.current.checked = false;
        } else if (selected && selected === total) {
            checkRef.current.indeterminate = false;
            checkRef.current.checked = true;
        } else {
            checkRef.current.indeterminate = false;
            checkRef.current.checked = false;
        }
    }, [total, selected]);

    return (
        <div className="flex flex-col">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div className="overflow-hidden border-b border-gray-200 shadow sm:rounded-lg">
                        <table className="min-w-full max-w-full divide-y divide-gray-200">
                            {props.children({ innerRef: checkRef })}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
